import * as React from "react";
import { JSX } from "react/jsx-runtime";

const TvIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m8.308 18.154 2.403-2.404a.082.082 0 0 1 .116 0l2.404 2.404m-5.744-6.565 2.145-2.298a.082.082 0 0 1 .099-.016l2.07 1.109c.036.02.08.01.105-.023l2.145-2.874m-8.04 8.205h9.517c.92 0 1.379 0 1.73-.179a1.64 1.64 0 0 0 .717-.717c.179-.351.179-.81.179-1.73V6.01c0-.92 0-1.379-.179-1.73a1.64 1.64 0 0 0-.717-.717c-.351-.179-.81-.179-1.73-.179H6.01c-.919 0-1.378 0-1.73.18-.308.156-.559.408-.716.716-.18.351-.18.81-.18 1.73v7.056c0 .92 0 1.379.18 1.73.157.309.408.56.717.717.35.179.81.179 1.73.179Z"
    />
  </svg>
);
export default TvIcon;
